import { Component, Input, EventEmitter, Output, OnInit } from '@angular/core';
import { get, isEmpty, merge, toString } from 'lodash';
import {
  IWizardContentComponent,
  IValueChangedEvent,
  IComponentStateHistory
} from '../../../wizard.content';
import { ValuesExchangeProvider } from '@nrwl/common-lib';

@Component({
  selector: 'threshold-settings-page',
  templateUrl: './threshold.settings.page.html'
})
export class ThresholdSettingsComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();

  loadedThresholds: any = ''; //eslint-disable-line @typescript-eslint/no-explicit-any
  isLoading = false;
  thresholds: any = {}; //eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(private readonly exchange: ValuesExchangeProvider) {}

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  get data(): any {
    return get(this.thresholds, 'data', {});
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  get hasChanged(): any {
    if (this.wizardCtrl.wizardService.editMode) {
      return (
        !isEmpty(this.thresholds) &&
        JSON.stringify(this.thresholds) !== this.loadedThresholds &&
        this.isValidThreshold()
      );
    } else {
      return !isEmpty(this.thresholds);
    }
  }
  isValidThreshold(): boolean {
    return (
      this.thresholds.maxValue >= parseFloat(this.thresholds.valueTo) &&
      parseFloat(this.thresholds.valueTo) > parseFloat(this.thresholds.valueFrom)
    );
  }

  ngOnInit() {
    this.wizardCtrl.toggleFinish = this.save.bind(this);
    this.loadThresholds();
  }

  loadThresholds(): void {
    this.thresholds = merge({}, this.step.parent.defaultParamsById, this.step.parent.output);
    this.loadedThresholds = JSON.stringify(this.thresholds);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  thresholdChanged(): void {
    setTimeout(() => {
      this.updateValidation();
    }, 0);
  }

  updateValidation(): void {
    this.step.valid = this.hasChanged;
    this.wizardCtrl.getWizardService().dirtyFlag = this.step.valid;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'thresholdInput',
      key: 'thresholdInput',
      newValue: this.thresholds,
      isValid: this.step.valid
    });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  onFailLoad(): void {
    this.thresholds = {};
  }

  save(): void {
    this.wizardCtrl.getWizardService().dirtyFlag = false;
    if (this.thresholds.mode === 'add') {
      if (this.thresholds.dimensionValue === 'site') {
        const siteId = this.step.parent.output['siteId'];
        this.thresholds['staticValues'] = toString(siteId);
      } else if (this.thresholds.dimensionValue === 'app') {
        const appId = this.step.parent.output['appId'];
        this.thresholds['staticValues'] = toString(appId);
      } else if (this.thresholds.dimensionValue === 'appSite') {
        const siteId = this.step.parent.output['siteId'];
        const appId = this.step.parent.output['appId'];
        this.thresholds['staticValues'] = appId + ',' + siteId;
      }
    }
    this.exchange.notifyListeners('update_threshold', this.thresholds);
    this.wizardCtrl.toggleClose();
  }
}
